import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformResponseHandler } from "utils/transformResponseHandler";

export const login = createApi({
  reducerPath: "login",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_ROUTE,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.posData?.token;
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: `/admin-login`,
        method: "POST",
        body: body,
      }),
      transformResponse: (res) => transformResponseHandler(res),
      transformErrorResponse: (error) => transformResponseHandler(error, true),
    }),
    logout: builder.mutation({
      query: (body) => ({
        url: `/logout`,
        method: "POST",
      }),
      // transformResponse: (res) => transformResponseHandler(res),
      transformErrorResponse: (error) => transformResponseHandler(error, true),
    }),
    getVendorDetails: builder.query({
      query: () => ({
        url: `/vendor-details`,
        method: "GET",
      }),
      transformResponse: (res) => transformResponseHandler(res),
      transformErrorResponse: (error) => transformResponseHandler(error, true),
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useGetVendorDetailsQuery } = login;

const initialState = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPOSData: (state, action) => {
      if (!action.payload) return {};
      return {
        ...action.payload,
        lastFetchedTime: action.payload?.lastFetchedTime || Date.now(),
      };
    },
    updatePOSVendorDetails: (state, action) => {
      if (!action.payload) return state;
      const existingToken = state?.token;
      return {
        ...action.payload,
        token: existingToken || action.payload?.token,
        lastFetchedTime: Date.now(),
      };
    },
    removePOSData: () => {
      return {};
    }
  },
});

export const { setPOSData, updatePOSVendorDetails, removePOSData } = userSlice.actions;
export default userSlice.reducer;